require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/$.core').Object.setPrototypeOf;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/fn/object/set-prototype-of.js
 ** module id = 101
 ** module chunks = 1
 **/